import { Component, OnDestroy, OnInit } from '@angular/core';
import { GameSelectionComponent } from '../../components/game-selection/game-selection.component';
import { RaceComponent } from '../../components/race/race.component';
import { MeetingComponent } from '../../components/meeting/meeting.component';
import { HeaderComponent } from '../../components/header/header.component';
import { PmuService } from '../../services/data/pmu.service';
import { filter, Subscription } from 'rxjs';
import { Pari } from '../../models/pari.model';
import { Meeting } from '../../models/meeting.model';
import { Race } from '../../models/race.model';
import { Game } from '../../models/game.model';
import { Router } from '@angular/router';
import { LocaleService } from '../../services/locale/locale.service';

@Component({
  selector: 'app-list-games',
  imports: [GameSelectionComponent, RaceComponent, MeetingComponent, HeaderComponent],
  templateUrl: './list-games.component.html',
  styleUrl: './list-games.component.scss',
})
export class ListGamesComponent implements OnInit, OnDestroy {

  gameSubscription: Subscription = new Subscription();
  raceSubscription: Subscription = new Subscription();
  meetingSubscription: Subscription = new Subscription();
  pariSubscription: Subscription = new Subscription();
  availableLocales = ['en-US', 'fr-FR'];
  selectedLocale =  localStorage.getItem('lang') ?? 'en-US';

  get selectedLang(){
    return this.selectedLocale.split('-')[0];
  }

  meetings: Meeting[] = [];
  races: Race[] = [];
  games: Game[] = [];

  pari: Partial<Pari> = {};

  constructor(private readonly pmuService: PmuService, public router: Router, private readonly localeService: LocaleService){
    this.pari = this.pmuService.getCurrentData();
    this.localeService.setLanguages(this.availableLocales);
    this.selectedLocale = localStorage.getItem('lang') ?? 'en-US';
    this.localeService.setLocale(this.selectedLocale);
  }

  get currentLocale(){
    return this.localeService.locale;
  }

  get betData() {
    return this.pmuService.getCurrentData();
  }

  switchLanguage(lang: string) {
    this.localeService.setLocale(lang);
    this.selectedLocale = lang;
    localStorage.setItem('lang', lang);
  }

  ngOnInit(): void {
    this.pariSubscription = this.pmuService.data$.pipe(filter(( value ) => (value.race?.id > 0 || value.meeting?.id > 0 || value.game?.code?.length > 0) )).subscribe((updatedPari) => {
        if(updatedPari.meeting.id > 0 && this.pari.meeting?.id !== updatedPari.meeting.id){
            this.pari.meeting = updatedPari.meeting;
            this.loadRaces(updatedPari.meeting.id);
        }else if(updatedPari.race.id > 0 && updatedPari.meeting.id > 0 && this.pari.meeting?.id === updatedPari.meeting.id && this.pari.race?.id !== updatedPari.race?.id) {
            this.pari.race = updatedPari.race;
            this.loadGames(updatedPari.meeting.id, updatedPari.race.id)
        } else if(!!updatedPari.game) {
            this.pari.game = updatedPari.game;
        }
    });

    this.meetingSubscription = this.pmuService.getMeetings().subscribe(res => {
        this.meetings = res;
        if(!this.pari.meeting?.id){
            this.pmuService.updateData({ meeting: res[0], race: res[0].races[0]});
        }
    });

    if(this.pari.meeting?.id && this.pari.race) {
        this.loadRaces(this.pari.meeting.id);
        this.loadGames(this.pari.meeting.id, this.pari.race?.id);
    }
  }

  loadRaces(meeting: number) {
    this.raceSubscription.unsubscribe();
    this.raceSubscription = this.pmuService.getRaces(meeting).subscribe(res => {
        this.races = res;
        this.pmuService.updateData({ race: res[0]});
    });
  }

  loadGames(meeting: number, race: number) {
    this.gameSubscription.unsubscribe();
        this.gameSubscription = this.pmuService.getGames(meeting, race).subscribe(res => {
            this.games = res;
            if(!this.pari.game){
              this.pmuService.updateData({ game: res[0]});
          }
        });
  }

  updateBetRace(_raceNum: number) {
    const race = this.races.find(r => r.id === _raceNum);
    this.pmuService.updateData({race})
    this.loadGames(this.pari.meeting?.id ?? -1, _raceNum);
  }

  updateBetMeeting(_meetNum: number) {
    const meeting = this.meetings.find(rn => rn.id == _meetNum);
    this.pmuService.updateData({meeting: meeting});
    this.loadRaces(_meetNum);
  }

  completeGameSelection(game: Game){
    this.pmuService.updateData({ game: game,
      race: {...this.pmuService.getCurrentData().race, horses: []}});
    this.router.navigate(['game-options']);
  }

  ngOnDestroy(): void {
    this.pariSubscription.unsubscribe();
    this.gameSubscription.unsubscribe();
    this.raceSubscription.unsubscribe();
    this.meetingSubscription.unsubscribe();
  }
}
